<template>
    <div class="d-flex flex-column col-12 p-0 m-0" >
        <div class="mh-60-vh overflow-auto">
            <p class="fs-5 mb-3">Adjust the count numbers using the blue arrows and then click “Save” once no count <br> </br> number conflicts.</p>
            <table class="border-right border-left border-bottom fs-5 ">
                <thead>
                    <tr>
                        <!-- <th class="fs-5">Select</th> -->
                        <th class="fs-5 pl-5" style="min-width: 150px">Count</th>
                        <th class="fs-5 ta-l" style="min-width: 150px">Section</th>
                        <th class="fs-5 ta-l" style="min-width: 150px">Description</th>
                        <th class="fs-5" style="min-width: 150px">Severity</th>

                    </tr>
                </thead>
                <tbody v-if="tempCountNumberArray?.length > 0">
                    <tr v-for="(chg, i) in tempCountNumberArray" :key="chg.Id">
                        <!-- <td class="ta-c">
                            <input type="checkbox" v-model="chg.IsSelected" />
                        </td> -->
                        <td>
                            <div class="d-flex align-items-center justify-content-center">

                                <input type="number" v-model.number="chg.CountNumber" class="form-control no-spinners" style="max-width: 60px;" :min="chg.CrimeTypeId == 1 || chg.CrimeTypeId == 3 ? 0 : 1" :class="(conflictingCountNumbers.includes(chg.CountNumber) && chg.CrimeTypeId == 5) ? 'error-border' : ''" />

                                <div class="d-flex flex-column ml-2" style="width: 30px;">
                                    <i @click="increaseCountNumber(chg)" class="fa fa-arrow-up button-color clickable mb-2"></i>
                                    <i @click="decreaseCountNumber(chg)" class="fa fa-arrow-down button-color clickable"></i>
                                </div>
                            </div>


                            <!-- <input type="number" v-model="chg.CountNumber" class="form-control" style="max-width: 80px"
                                :min="chg.CrimeTypeId == 1 || chg.CrimeTypeId == 3 ? 0 : 1"
                                :class="(conflictingCountNumbers.includes(chg.CountNumber) && chg.CrimeTypeId == 5) ? 'error-border' : ''" /> -->



                            <!-- <td class="pl-3" v-if="crime.CrimeTypeId == 5"> -->

                            <!-- <div class="d-flex align-items-center justify-content-center">
                  <span class="pr-3">
                    {{ chargeToAdd.currentCount }}

                  </span>
                  <div class="d-flex flex-column" style="width: 30px;">
                    <i @click="increaseCountNumber(chargeToAdd)"
                      class=" fa fa-arrow-up button-color clickable mb-2"></i>
                    <i @click="decreaseCountNumber(chargeToAdd, chargeToAdd.currentCount)"
                      class=" fa fa-arrow-down button-color clickable"></i>
                  </div>
                </div> -->

                            <!-- </td> -->


                        </td>
                        <td class="ta-l">{{ chg.SectionNumber }}</td>
                        <td class="ta-l">{{ chg.Name }}</td>
                        <td>
                            <span v-if="chg.CrimeTypeId == 5">
                                {{ ['Infraction', 'Misdemeanor', 'Felony'][chg.CrimeSeverityId - 1] }}
                            </span>
                            <span v-else-if="chg.CrimeTypeId == 6">
                                Enhancement
                            </span>
                        </td>
                    </tr>
                </tbody>
                <!-- <tfoot>
                    <tr>
                        <td class="ta-c">
                            <button class="btn btn-primary" @click="toggleAll">All</button>
                        </td>
                        <td>
                            <button class="btn btn-primary-outline mr-3" @click="incrementCountNumbers">
                                <i class="fs-5 fa fa-plus"></i>
                                 Increment Up
                            </button>
                            <button class="btn btn-primary-outline" @click="decrementCountNumbers">
                                <i class="fs-5 fa fa-minus"></i>
                                 Decrement Down
                            </button>
                            
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                </tfoot> -->
            </table>
        </div>

        <p class="error" v-if="error?.length > 0">There are duplicate count numbers: {{ conflictingCountNumbers.join(', ') }} </p>
        <div class="mt-3 w-100 d-flex justify-content-center">
           <button class="btn btn-primary mr-3" 
        :disabled="!changesMade || conflictingCountNumbers.length > 0" 
        :class="{ 'saving-disabled': saving }"
        @click="saveChanges">
    <i v-if="saving" class="fa fa-check text-success"></i>
    {{ saving ? 'Saved' : 'Save' }}
</button>

        </div>


    </div>
</template>
<script>
import axios from "axios";
import SC from "../../../components/utils/sharedComponent.vue";
export default {
    name: "CountNumberFixer",
    props: ["charges"],
    data() {
        return {
            selectedCountNumber: 0,
            tempCountNumberArray: [],
            saving: false,
            showInsertCountNumberOption: false,
            selectedCountNumberToInsertAt: 1,
            showInsertCountNumberCrimeModal: false,
        }
    },
    components: {SC},
    computed: {
        allSelected() {
            if (this.tempCountNumberArray.some(chg => chg.IsSelected == false)) {
                return false
            } else {
                return true
            }
        },
        changesMade() {
            let changesMade = false;
            for (let i = 0; i < this.charges.length; i++) {
                if (this.charges[i].CountNumber != this.tempCountNumberArray[i]) {
                    changesMade = true;
                    break;
                }
            }
            return changesMade;
        },
        conflictingCountNumbers() {
            let badCountNumbers = [];
            this.tempCountNumberArray.forEach(chg => {
                if (chg.CrimeTypeId == 5) {
                    let conflictingCountNumber = this.tempCountNumberArray.findIndex((otherChg) => otherChg.CountNumber == chg.CountNumber && otherChg.CrimeTypeId == 5 && chg.Id != otherChg.Id);
                    if (conflictingCountNumber !== -1 && !badCountNumbers.includes(chg.CountNumber)) {
                        badCountNumbers.push(chg.CountNumber)
                    }
                }
            });
            return badCountNumbers;
        },

    },
    methods: {

        //increase by 1, accounts for null or undefined
        increaseCountNumber(chg) {
            chg.CountNumber = (chg.CountNumber || 0) + 1;
        },

        //decrease, don't go below 1
        decreaseCountNumber(chg) {
            const minValue = (chg.CrimeTypeId === 1 || chg.CrimeTypeId === 3) ? 0 : 1;

            if (chg.CountNumber > minValue) {
                chg.CountNumber -= 1;
            }
        },

        emitInsertChargeBetweenCounts(){
            this.$emit('insertChargeBetweenCounts', this.selectedCountNumberToInsertAt)
        },
        toggleAll() {
            const direction = !this.allSelected
            this.tempCountNumberArray.forEach(chg => {
                chg.IsSelected = direction
            })
        },
        incrementCountNumbers() {
            this.tempCountNumberArray.forEach(chg => {
                if (chg.IsSelected) {
                    chg.CountNumber++
                }
            })
            this.sortTempCountNumbers()
        },
        decrementCountNumbers() {
            this.tempCountNumberArray.forEach(chg => {
                if (chg.IsSelected && (chg.CountNumber > 1)) {
                    chg.CountNumber--
                }
            });
            this.sortTempCountNumbers()
        },
        sortTempCountNumbers() {
            this.tempCountNumberArray.sort((a, b) => a.CountNumber - b.CountNumber)
        },
        async saveChanges() {
            this.saving = true;
             this.error = null;
            if (this.conflictingCountNumbers.length > 0) {
                this.error = `There are duplicate crimes charged to the following count numbers: ${this.conflictingCountNumbers.join(', ')}        `
                this.saving = false;
                return await setTimeout(() => {
                    this.error = null;
                    return;
                }, 3000);
            }
            this.tempCountNumberArray.forEach(async (chg, i) => {
                if (chg.CountNumber != chg.OriginalCountNumber) {
                    let foundIndex = this.charges.findIndex((otherChg) => otherChg.Id == chg.Id);
                    if (foundIndex !== -1) {
                        this.charges[foundIndex].CountNumber = chg.CountNumber;
                        await SC.postChargeField(localStorage.getItem('user_token'), chg.Id, 'CountNumber', chg.CountNumber)
                    }

                }
            });
            this.sortTempCountNumbers()
            this.$emit('onCalc');
            setTimeout(() => {
                this.saving = false;
            }, 2000);

        },

    },
    watch: {
        selectedCountNumberToInsertAt: function (val) {
            if (val < 1) {
                this.selectedCountNumberToInsertAt = 1;
            }
        }
    },
    mounted() {
        this.charges.forEach(chg => {
            if (chg.CrimeTypeId !== 1 && chg.CrimeTypeId !== 3) {
                this.tempCountNumberArray.push({
                    OriginalCountNumber: chg.CountNumber,
                    CountNumber: chg.CountNumber,
                    Id: chg.Id,
                    CrimeTypeId: chg.CrimeTypeId,
                    IsSelected: false,
                    Name: chg.Name,
                    SectionNumber: `${chg.SectionNumber}`,
                    CrimeSeverityId: chg.CrimeSeverityId
                })
            }

        })
    },
}
</script>
<style scoped>

.saving-disabled {
    pointer-events: none;
    /* opacity: 0.6; */
}

.error-border {
    border: 1px solid red !important;
}
.mh-60-vh {
    max-height: 60vh !important;
}

.no-spinners::-webkit-inner-spin-button,
.no-spinners::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-spinners {
  -moz-appearance: textfield;
}


</style>